function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 195.001,
  cy: 191.389,
  r: 14.169
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 168.001,
  y: 322.959,
  width: 52,
  height: 47
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M194.101,20.043l-114.483,98.01l14.468,16.835l94.821-80.795c2.995-2.552,7.402-2.547,10.391,0.012l94.427,80.816 l14.8-16.914L194.101,20.043z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.863,201.959c-6.625,0.086-11.93,5.517-11.862,12.142v155.858h101v-168H11.863z M38.001,326.209c0,4.418-3.582,8-8,8 s-8-3.582-8-8v-17.191c0-4.418,3.582-8,8-8s8,3.582,8,8V326.209z M38.001,259.252c0,4.418-3.582,8-8,8s-8-3.582-8-8v-17.193 c0-4.418,3.582-8,8-8s8,3.582,8,8V259.252z M79.001,326.209c0,4.418-3.582,8-8,8s-8-3.582-8-8v-17.191c0-4.418,3.582-8,8-8 s8,3.582,8,8V326.209z M79.001,259.252c0,4.418-3.582,8-8,8s-8-3.582-8-8v-17.193c0-4.418,3.582-8,8-8s8,3.582,8,8V259.252z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M193.715,70.703l-76.714,65.256v234h35v-55.061c-0.128-4.255,3.217-7.807,7.471-7.935c0.08-0.002,0.16-0.004,0.24-0.003 h68.768c4.418,0,7.521,3.521,7.521,7.939v55.061h34V135.888L193.715,70.703z M195.001,161.217 c16.655,0.017,30.152,13.514,30.169,30.169c0,16.662-13.507,30.169-30.169,30.169s-30.169-13.507-30.169-30.169 S178.339,161.217,195.001,161.217z M228.48,274.959h-69.22c-4.418,0-8-3.582-8-8s3.582-8,8-8h69.22c4.418,0,8,3.582,8,8 S232.898,274.959,228.48,274.959z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M378.139,201.959h-92.138v168h104V214.101C390.069,207.476,384.763,202.045,378.139,201.959z M327.001,326.209 c0,4.418-3.582,8-8,8s-8-3.582-8-8v-17.193c0-4.418,3.582-8,8-8s8,3.582,8,8V326.209z M327.001,259.25c0,4.418-3.582,8-8,8 s-8-3.582-8-8v-17.191c0-4.418,3.582-8,8-8s8,3.582,8,8V259.25z M367.001,326.209c0,4.418-3.582,8-8,8s-8-3.582-8-8v-17.193 c0-4.418,3.582-8,8-8s8,3.582,8,8V326.209z M367.001,259.25c0,4.418-3.582,8-8,8s-8-3.582-8-8v-17.191c0-4.418,3.582-8,8-8 s8,3.582,8,8V259.25z"
})));

var SvgCityHall = function SvgCityHall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390.001 390.001",
    style: {
      enableBackground: "new 0 0 390.001 390.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCityHall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/city-hall.dc189429.svg";
export { ForwardRef as ReactComponent };